import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAhociFioeaEGgRo9hg2U3Zfjf7XZoF1mA",
  authDomain: "project-management-9ed30.firebaseapp.com",
  databaseURL: "https://project-management-9ed30-default-rtdb.firebaseio.com",
  projectId: "project-management-9ed30",
  storageBucket: "project-management-9ed30.appspot.com",
  messagingSenderId: "1031311863922",
  appId: "1:1031311863922:web:780ea46d6b5f02c818d2eb",
  measurementId: "G-7M81C96HPG",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
